fragment CalcuraFieldListCategoryFragment on CalcuraFieldListCategory {

    id
    label
    position
    default_option

    media {
        ...MediaFragment
    }

    items {
        ...CalcuraFieldListItemFragment
    }

}